import { ReactNode, useContext, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import UserContext from '../../UserContext';

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { login, isAuthLoading } = useContext(UserContext);

  if (isAuthLoading) {
    return <>Carregando...</>;
  }

  if (login === true) return <>{children}</>;
  /* else if (login === false)  */ return <Navigate to="/" />;
  // else return <></>;
};

export default ProtectedRoute;
